import React from "react";
import TextArea from "components/FormElements/TextArea";

function LongtextMetaProperty(props) {
    return <TextArea name={props.name} />;
}

export default LongtextMetaProperty;

export const Property = LongtextMetaProperty;

export const Label = "Text Area";
